window.REBASE = window.REBASE || {};
REBASE.theme = REBASE.theme || {};

(function($) {
  $(function() {
    REBASE.theme.IS_PRODUCT_TEMPLATE = $('body').hasClass('product-template');

    if ( REBASE.theme.IS_PRODUCT_TEMPLATE ){
      REBASE.theme.bindProductControls();
    }

    REBASE.theme.is_mobile = window.innerWidth < 1040;

        $(document).on('click', '.dropdown__option', function(e) {
      e.preventDefault();
    
        let isPreOrderEnabled = $('#preOrderEnabled').val();
//       debugger;
      $('.dropdown__option').removeClass('dropdown__option--selected');
      $(this).addClass('dropdown__option--selected');
      $('.dropdown__option input').prop('checked', false);
      if($(this).hasClass('available')){
        const $radios = $(this).children('input[type=radio]')
        if ($radios.is(':checked') === false) {
          $radios.prop('checked', true);
        }
        $('#add-to-cart').removeClass('disabled').removeAttr('disabled');
        $('#add-to-cart').attr('aria-disabled', false);
        if(isPreOrderEnabled !== "" && isPreOrderEnabled !== undefined){
         $('#add-to-cart-text').text('PRE-ORDER NOW');
          $('#add-to-cart').text('PRE-ORDER NOW');
        } else {
         $('#add-to-cart-text').text('Add To Bag');
          $('#add-to-cart').text('Add To Bag');
        }
        // console.log("5sold out");
        $('#add-to-cart').removeClass('d-none');
        $('#notify-text-button').addClass('d-none');
      }else{
        $('#back-stock-limited p').hide();
        var tags = $('#productTags').val();
        if(tags.includes('final-sale:1')) {
        	$('#add-to-cart').addClass('disabled').attr('disabled', 'disabled');
          $('#add-to-cart').attr('aria-disabled', true);
            $('#add-to-cart-text').text('Sold Out');
          $('#add-to-cart').text('Sold Out');
        //  console.log("6sold out");
          // $('#add-to-cart').addClass('d-none');
        	// $('#notify-text-button').removeClass('d-none');
        }
        else {
        	$('#add-to-cart').addClass('d-none');
        	$('#notify-text-button').removeClass('d-none');
           
        }
      }
      var swatches = JSON.parse(document.getElementById('variant__inv').innerHTML);
      var currentId = parseInt($(this).attr('id'));
      for(var i = 0; i < swatches.variants.length; i++){
        if(currentId == swatches.variants[i].id){
          if(swatches.variants[i].inv <= 4){
            if($(this).hasClass('dropdown__option--sold-out')){
            // console.log("sold out");
              $('#add-to-cart').text('Sold Out');
            }else{
             $('#back-stock-limited p').show();
              // console.log("2else sold out");
              if(isPreOrderEnabled !== "" && isPreOrderEnabled !== undefined){
                $('#add-to-cart-text').text('PRE-ORDER NOW');
                $('#add-to-cart').text('PRE-ORDER NOW');
              } else {
                $('#add-to-cart').text('Add To Bag');
              }

            }
          }else{
            $('#back-stock-limited p').hide();
            //  console.log("3else sold out");
              if(isPreOrderEnabled !== "" && isPreOrderEnabled !== undefined){
                $('#add-to-cart-text').text('PRE-ORDER NOW');
                $('#add-to-cart').text('PRE-ORDER NOW');
              } else {
                $('#add-to-cart').text('Add To Bag');
              }
          }
        }
      }     
          
          
    });

//     $(document).on('click', '.swatch-element', function(e) {
//       var cruntColor = $(this).children().val();
//       var swatches = JSON.parse(document.getElementById('variant__inv').innerHTML);
//       $('#swathes-load-id').empty();
//       var currentColorList = [];
//       for(var i = 0; i < swatches.variants.length; i++){
//         var swatchesColor = swatches.variants[i].option1;
//         var swatchesSize = swatches.variants[i].option2;

//         if(cruntColor === swatchesColor.trim()){
//           if(swatches.variants[i].inv > 0){
//             currentColorList.push(`<div id="${swatches.variants[i].id}" data-varaint-id="${swatches.variants[i].id}" class="dropdown__option available" tabindex="0" data-label="0" data-position="2" data-value="${swatches.variants[i].option2}"><input type="radio" name="single-option-select-2" id="swatch-2-${swatches.variants[i].option2}" value="${swatches.variants[i].option2}" data-index="option2" class="single-option-select visually-hidden"><label for="swatch-2-${swatches.variants[i].option2}"><div>${swatches.variants[i].option2}</div></label></div>`);
//           }else{
//             currentColorList.push(`<div id="${swatches.variants[i].id}" data-varaint-id="${swatches.variants[i].id}" class="dropdown__option dropdown__option--sold-out" tabindex="0" data-label="0" data-position="2" data-value="${swatches.variants[i].option2}"><input type="radio" name="single-option-select-2" id="swatch-2-${swatches.variants[i].option2}" value="${swatches.variants[i].option2}" data-index="option2" class="single-option-select visually-hidden"><label for="swatch-2-${swatches.variants[i].option2}"><div>${swatches.variants[i].option2}</div></label></div>`);
//           }

//         }
//       }
	
      

//       $('#swathes-load-id').append(currentColorList);

//       $('.dropdown__option.available').each(function(index, obj) {
//         if (index === 0) {
//           const $radios = $(`#${obj.id} input[type=radio]`);
//           if ($radios.is(':checked') === false) {
//             $radios.prop('checked', true);
//           }
//           var currentId = parseInt(obj.id);
//       for(var i = 0; i < swatches.variants.length; i++){
//         if(currentId == swatches.variants[i].id){
//           if(swatches.variants[i].inv <= 4){
//             $('#back-stock-limited p').show();
//           }else{
//             $('#back-stock-limited p').hide();
//           }
//         }
//       }
//         }


//       });



//     });


  });

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Setup Product page controls (needs to run on product pages and when quickview is opened)
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/
  REBASE.theme.handleizeStr = function(str) {
    if ( str === null || typeof str === 'undefined' ){return ''}
    str = str.toLowerCase();

    // list of special characters we want to drop completely
    var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

    // For the old browsers
    for (var i = 0; i < toReplace.length; ++i) {
      str = str.replace(toReplace[i], "");
    }

    // all non-alphanumeric and non-underscore
    str = str.replace(/\W+/g, "-");

    // if last character is a hyphen, drop it
    if (str.charAt(str.length - 1) == "-") {
      str = str.replace(/-+\z/, "");
    }

    // if first character is a hyphen, drop it
    if (str.charAt(0) == "-") {
      str = str.replace(/\A-+/, "");
    }

    return str;
  }

  REBASE.theme.appendToFilename = function(filename, str) {
    var dot_indx = filename.lastIndexOf('.');

    if (dot_indx === -1) {
      return filename + str;
    } else {
      return filename.substring(0, dot_indx) + str + filename.substring(dot_indx);
    }
  };

  REBASE.theme.unbindProductControls = function() {
    $('.product-header__reviews, .product-info__tabs a').off('.rbProduct');
  };

  REBASE.theme.initProductGallery = function() {
    // Image Galleries
    setTimeout(function () {
      REBASE.theme.product_photo_gallery = new Swiper('.gallery', {
        effect: 'slide',
        loop: true,
        speed: 300,
        slidesPerView: 1.75,
        centeredSlides: true,
        spaceBetween: 30,
        navigation: {
          nextEl: '.gallery-button__next',
          prevEl: '.gallery-button__prev'
        },
        observer: true,
        observeParents: true,
      });
    }, 3000);
  }

  // var lastWindowWidth = 0;
  // function toggleMobilePDPForm() {
  //   var willToggle = false,
  //     isMobile = window.innerWidth < 960;

  //   if ( window.innerWidth > 960 ) {
  //     if ( lastWindowWidth === 0 || lastWindowWidth < 960) {
  //       willToggle = true;
  //       lastWindowWidth = window.innerWidth;
  //     }
  //   } else {
  //     if ( lastWindowWidth === 0 || lastWindowWidth > 960) {
  //       willToggle = true;
  //       lastWindowWidth = window.innerWidth;
  //     }
  //   }

  //   if ( !willToggle ) {return false}

  //   if ( isMobile ) {
  //     var options = $('.product-option-row').detach();
  //     var button = $('.product-action__btn').detach();
  //     // var estimate = $('.shipping-estimate').detach();
  //     $('.mobile-product-form-actions').append(options);
  //     $('.mobile-product-form-actions').append(button);
  //     // $('.mobile-product-form-actions').append(estimate);
  //   } else {
  //     var options = $('.product-option-row').detach();
  //     var button = $('.product-action__btn').detach();
  //     // var estimate = $('.shipping-estimate').detach();
  //     $('.product-option-rows').append(options);
  //     $('.product-action').append(button);
  //     // $('.product-action').before(estimate);
  //   }
  // }

  // Removed on 2/23/21 by request of client - may re-enable after launch

  // Couple of methods on the Date object to help see if we are in DST or not
  // Date.prototype.stdTimezoneOffset = function() {
  //   var jan = new Date(this.getFullYear(), 0, 1);
  //   var jul = new Date(this.getFullYear(), 6, 1);
  //   return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  // }

  // Date.prototype.isDst = function() {
  //   return this.getTimezoneOffset() < this.stdTimezoneOffset();
  // }

  // function addShippingDays(days, date) {
  //   for ( let i = 0; i < days; i++ ) {
  //     date.setDate(date.getDate() + 1); // add one day per our loop

  //     // if we are now on a saturday, add 2 days to get to monday
  //     if ( date.getDay() == 6 ) {
  //       date.setDate(date.getDate() + 2);
  //     }

  //     // if we are now on a sunday, add 1 day to get to monday
  //     if ( date.getDay() == 0 ) {
  //       date.setDate(date.getDate() + 1);
  //     }
  //   }

  //   return date;
  // }

  // // get the local time based on the offset from global theme settings
  // function getCurrentLocalTime() {
  //   let date = new Date();
  //   let offset = (date.isDst() ? -4 : -5);
  //   let utc = date.getTime() + (date.getTimezoneOffset() * 60000);
  //   return new Date(utc + (3600000 * offset));
  // }

  // function setEstimatedDeliveryDate() {
  //   var container = $('.shipping-estimate'),
  //     currentTime = getCurrentLocalTime()  ,
  //     formattedDate;

  //   // add a day if we're past the cutoff time of 11am
  //   if ( currentTime.getHours() >= 10 ) {
  //     currentTime.setDate(currentTime.getDate() + 1);
  //   }

  //   // add our 5 days, skipping over weekends
  //   currentTime = addShippingDays(5, new Date(currentTime))

  //   // format it for display
  //   formattedDate = `${new Intl.DateTimeFormat('en-US', {month: 'long', day: 'numeric', year: 'numeric' }).format(currentTime)}`

  //   // display!
  //   container.find('span').text(formattedDate)
  //   container.removeClass('shipping-estimate--hidden')
  // }

  REBASE.theme.bindProductControls = function() {

    // Image Galleries
    // REBASE.theme.initProductGallery();

    $(document).on('click', '.product-qty__minus', function(e) {
      e.preventDefault();
      var el = $('#quantity'),
          newValue = parseInt(el.val()) - 1;
      if ( newValue >= 1 ) {
        el.val(newValue);
      }
    });

    $(document).on('click', '.product-qty__plus', function(e) {
      e.preventDefault();
      var el = $('#quantity');
      el.val(parseInt(el.val()) + 1);
    });

    // toggleMobilePDPForm();
    // $(window).on('resize', toggleMobilePDPForm)

    // setEstimatedDeliveryDate();

    // Option Selectors & Swatches
    // NOTE: must come after image gallery (for selected variant to show correct image when loading page)
    product = new REBASE.theme.Product({
      $container: $('#add-to-cart-form'),
      quickView: true
    });
  };

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Product class
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  REBASE.theme.Product = (function() {
    function Product(options) {
      var inputs, input_type;

      this.variants = null;
      this.$container = options.$container;
      this.data = JSON.parse(document.getElementById('product__json').innerHTML);
      this.dataNew = JSON.parse(document.getElementById('variant__inv').innerHTML);
      this.images = this.data.images;
      this.media = this.data.media;
      this.quickView = options.quickView || false;

      this.settings = {
        single_option_selector: '.single-option-select',
        original_select_id: 'select#product-select'
      };

      if (this.data) {
        this._initVariants();

        // Trigger change to sync up images, etc on initial page load
        inputs = $(this.settings.single_option_selector, this.$container);
        input_type = inputs.first().attr('type');

        if (input_type === 'radio' || input_type === 'checkbox') {
          inputs.filter(':checked:first').trigger('change');
        } else {
          inputs.first().trigger('change');
        }
      } else {
        if (console) {
          // console.log('Missing product json data!');
        }
      }
      $('.product-quickview__thumbs').slick({
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        vertical: true,
        prevArrow: '<div class="slick_button"><svg height="24" viewBox="0 0 14 24" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m165 368 10 10 10-10" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2.4" transform="matrix(0 1 -1 0 380 -163)"></path></svg></div>',
        nextArrow: '<div class="slick_button"><svg height="24" viewBox="0 0 14 24" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m699 368 10 10 10-10" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2.4" transform="matrix(0 1 1 0 -366 -697)"></path></svg></div>'
      });
    }

    Product.prototype = $.extend({}, Product.prototype, {
      _initVariants: function() {
        var options = {
          $container: this.$container,
          enable_history_state: !this.quickView,
          single_option_selector: this.settings.single_option_selector,
          original_select_id: this.settings.original_select_id,
          product: this.data,
          quickView: this.quickView || false
        };

        this.variants = new REBASE.theme.Variants(options);

        this.$container.on('variantChange', this._updateAddToCart.bind(this));
        this.$container.on('variantPriceChange', this._updatePrice.bind(this));
        this.$container.on('variantChange', this._updateColorLabel.bind(this));

        // images for quickview are a bit different, so handle them differently
        if ( this.quickView === true ) {
          this.$container.on('variantChange', this._updateQuickViewDetailsLink.bind(this));
          this.$container.on('variantImageChange', this._updateQuickViewMedia.bind(this));
          
          //  setTimeout(function(){ 
          //     $('.dropdown__option.available').each(function(index, obj) {
          //         if (index === 0) {
          //           $('.dropdown__option').removeClass('dropdown__option--selected');
      		// 		// $(this).addClass('dropdown__option--selected');
          //           const $radios = $(`#${obj.id} input[type=radio]`);
          //           if ($radios.is(':checked') === false) {
          //             $radios.prop('checked', false);
          //             $('#add-to-cart').removeClass('disabled').removeAttr('disabled');
          //     		$('#add-to-cart').text('Select A Size');
          //           }
          //         }
          //     });
          // }, 800);
          
        } else {
          this.$container.on('variantImageChange', this._updateMedia.bind(this));
        }
      },

      _updateColorLabel: function(e) {
//         $('#option-name--option1 span').text(e.variant.option1);
      },

      _updatePrice: function(e) {
        var variant = e.variant;

        $('.product-price:not(.product-price--old)').html(Shopify.formatMoney(variant.price, ''));
        if ( variant.price < variant.compare_at_price ) {
          $('.product-price--old').html(Shopify.formatMoney(variant.compare_at_price, ''));
          $('.product-price:not(.product-price--old)').addClass('product-price--on-sale');
          $('.product__final-sale').addClass('visible');
        } else {
          $('.product-price--old').html('');
          $('.product-price:not(.product-price--old)').removeClass('product-price--on-sale');
          $('.product__final-sale').removeClass('visible');
        }
      },

      _updateAddToCart: function(e) {
        var variant = e.variant,
            all_variants_match_option1 = e.all_variants_match_option1,
            target = $(e.target),
            input_type = target.attr('type'),
            btn = $('#add-to-cart'),
            btn_txt = $('#add-to-cart-text'),
            variantNew = this.dataNew,
            tags = this.data.tags;
        
        if (!variant) {
          btn.addClass('disabled').attr('disabled', 'disabled');
          btn.attr('aria-disabled', true);
          btn_txt.text('Not Available');
        } else {
          if (variant.available) {

              // btn.removeClass('disabled').removeAttr('disabled');
              btn_txt.text(btn_txt.data('add-to-cart-text'));
              btn.removeClass('d-none');
              $('#notify-text-button').addClass('d-none');
          } else {
            var tags = $('#productTags').val();
            if(tags.includes('final-sale:1')) {
                btn.addClass('disabled').attr('disabled', 'disabled');
                btn.attr('aria-disabled', true);
            	btn_txt.text(btn_txt.data('sold-out-text'));
              	btn.removeClass('d-none');
                $('#notify-text-button').addClass('d-none');
            }
            else {
            	// btn.addClass('d-none');
            	$('#notify-text-button').removeClass('d-none');
            }
          }
        }

        if (input_type === 'radio' || input_type === 'checkbox') {
          target.parent('.swatch-element').addClass('selected-swatch').siblings().removeClass('selected-swatch');

          // MODDED FOR SWATCH AVAILABILITY (only one level deep, option2)
            var option2_inputs = $('.product-option-row--size, .product-option-row--accessory-size').find('input[data-index="option2"]'),
              option2_vals = option2_inputs.map(function() {return $(this).val();}).get(),
              option2_not_available = $.map(option2_vals, function(option_val) {
                var is_available = false;
                option2_inputs.parent('.dropdown__option').addClass('available');
                $.each(all_variants_match_option1, function(i, match_variant) {
                  if (match_variant.option2 === option_val) {
                    if (match_variant.available) {
                      is_available = true;
                    }
                  }
                });

                if (is_available) {
                  return undefined;
                } else {
                  return option_val;
                }
              });

          option2_inputs.parent('.swatch-element').removeClass('swatch--unavailable');
          option2_inputs.parent('.dropdown__option').removeClass('dropdown__option--sold-out').find('.dropdown__option-label span').remove();
          option2_inputs.parent('.dropdown__option').find('.dropdown__option-label').removeClass('back-in-stock-trigger');

          $.each(option2_not_available, function(indx, option_val) {
            option2_inputs.each(function() {
              var current_option_input = $(this);

              if (current_option_input.val() === option_val) {
                current_option_input.parent('.dropdown__option').removeClass('available');
                current_option_input.parent('.swatch-element').addClass('swatch--unavailable');
                current_option_input.parent('.dropdown__option').addClass('dropdown__option--sold-out');
                current_option_input.parent('.dropdown__option').find('.dropdown__option-label').append('<span>Sold Out </span>')
                if ( !tags.includes('final-sale:1') ) {
                  current_option_input.parent('.dropdown__option').find('.dropdown__option-label').addClass('back-in-stock-trigger');
                  current_option_input.parent('.dropdown__option').find('.dropdown__option-label').append('<span>Notify Me When Available</span>');
                }
              }
            });
          });
        }
        
        $('.dropdown__option.available').each(function(index, obj) {
          if (index === 0) {
            var swatcheList = JSON.parse(document.getElementById('variant__inv').innerHTML);
           
             const $radios = $(`#${obj.id} input[type=radio]`);
              if ($radios.is(':checked') === false) {
                $radios.prop('checked', false);
                // $radios.parent().addClass('dropdown__option--selected');
              }

            for(var i = 0; i < swatcheList.variants.length; i++){
              if(obj.id == swatcheList.variants[i].id ){
                if(swatcheList.variants[i].inv <= 4){
                  if($(this).hasClass('dropdown__option--sold-out')){
                    $('#add-to-cart').text('Sold Out');
                  }else{
                   $('#back-stock-limited p').show();
                    $('#add-to-cart').text('Select A Size');
                  }
                }else{
                  $('#back-stock-limited p').hide();
                  $('#add-to-cart').text('Select A Size');
                }
              }
            }

            //  btn.removeClass('disabled d-none').removeAttr('disabled');
             $('#notify-text-button').addClass('d-none');
             btn_txt.text(btn_txt.data('add-to-cart-text'));
//             if($(`#${obj.id}.dropdown__option`).hasClass('dropdown__option--sold-out')){
//             const availableId =  $('.dropdown__option').next('.dropdown__option.available').first().attr('id');
//               const $radios = $(`#${availableId} input[type=radio]`);
//               if ($radios.is(':checked') === false) {
//                 $radios.prop('checked', true);
//                 $(`#${availableId}.dropdown__option.available`).addClass('dropdown__option--selected');
                
//                 btn.removeClass('disabled').removeAttr('disabled');
//               	btn_txt.text(btn_txt.data('add-to-cart-text'));
//               }
//             }
            
          }


        });
      },

      _buildImgUrl: function(src, size) {
        // set a sensible default
        var replaceSize = size || '900x';

        // remove version parameter if exists
        src = src.split('?')[0];

        // get index of file extension so we can insert size before
        var ext_index = src.match(/(\.[\w\d_-]+)$/i).index;

        // return our rebuilt src url
        return src.slice(0, ext_index) + '_' + replaceSize + src.slice(ext_index);
      },

      _buildImage: function(media) {
        var div = document.createElement('div');
        var link = document.createElement('a');
        var img = document.createElement('img');

        link.href = this._buildImgUrl(media.src, '3000x');
        // link.classList.add('MagicZoom');

        img.src = this._buildImgUrl(media.src, '900x');
        img.srcset = this._buildImgUrl(media.src, '900x') + ' 1x, ' + this._buildImgUrl( media.src, '1800x') + ' 2x';

        div.classList.add('swiper-slide');

        link.appendChild(img);
        div.appendChild(link);
        return div;
      },

      _buildVideo: function(media) {
        var figure = document.createElement('figure');
        var video = document.createElement('video');

        video.playsinline = true;
        video.controls = true;
        
         video.autoplay = true;
        video.playsinline = true;
        video.poster = media.preview_image.src;

        media.sources.forEach(function(src){
          var source = document.createElement('source');
          source.src = src.url;
          source.type = src.mime_type;
          video.appendChild(source);
        });

        figure.classList.add('swiper-slide');

        figure.appendChild(video);
        return figure;
      },

      _buildExternalVideo: function(media) {
        var figure = document.createElement('figure'),
            container = document.createElement('div'),
            iframe = document.createElement('iframe');

        figure.classList.add('swiper-slide');
        container.classList.add('gallery-video-container');
        iframe.title = media.alt ? media.alt : this.data.title;
        iframe.allowfullscreen = 'allowfullscreen';
        iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        iframe.frameborder = '0';
        iframe.src = 'https://www.youtube.com/embed/' + media.external_id + '?controls=1&amp;enablejsapi=1&amp;modestbranding=1&amp;playsinline=1&amp;rel=0';

        container.appendChild(iframe);
        figure.appendChild(container);
        return figure;
      },

      _getMediaEl: function(media) {
        var el = null;

        switch(media.media_type) {
          case 'image':
            el = this._buildImage(media);
            break;
          case 'video':
            el = this._buildVideo(media);
            break;
          case 'external_video':
            el = this._buildExternalVideo(media);
            break;
        }

        return el;
      },
      _updateMedia: function(e) {
        var variant = e.variant,
            swiper_el = $('.product__part--gallery'),
            swiper_container = swiper_el.find('.swiper-container .swiper-wrapper');

        variant_media = this.data.media.filter( function(media) {
          if(media.media_type === 'video'){
            var div = document.createElement('div');
            return div;
          }else{
            var split_filename = media.src.match(/([^/]+\.(jpg|png))/gi)[0].split('_');

            return REBASE.theme.handleizeStr(split_filename[split_filename.length-2]).replace('-', "") === REBASE.theme.handleizeStr(variant.option1).replace('-', "") ||
              REBASE.theme.handleizeStr(split_filename[split_filename.length-2]).replace('-', "") === REBASE.theme.handleizeStr(variant.option2).replace('-', "") ||
              REBASE.theme.handleizeStr(split_filename[split_filename.length-2]).replace('-', "") === REBASE.theme.handleizeStr(variant.option3).replace('-', "");
          }        
        });


        swiper_container.fadeOut(200, function() {
          swiper_container.empty();
          variant_media.forEach(function(v) {
            swiper_container.append(this._getMediaEl(v));
          }.bind(this));

          REBASE.theme.product_photo_gallery.destroy();
          REBASE.theme.initProductGallery();

          setTimeout(function() {
            swiper_el.addClass('visible');
            swiper_container.addClass('visible');
            swiper_container.fadeIn(200);
            // MagicZoom.refresh();
          })
        }.bind(this));
      },

      _updateQuickViewMedia: function(e) {
        var variant = e.variant,
            variant_media,
            thumbs_container = $('.product-quickview__thumbs'),
            main_container = $('.product-quickview__image');

        variant_media = this.data.media.filter( function(media) {
          if(media.src) {
          var split_filename = media.src.match(/([^/]+\.(jpg|png))/gi)[0].split('_');

          return REBASE.theme.handleizeStr(split_filename[split_filename.length-2]).replace('-', "") === REBASE.theme.handleizeStr(variant.option1).replace('-', "") ||
            REBASE.theme.handleizeStr(split_filename[split_filename.length-2]).replace('-', "") === REBASE.theme.handleizeStr(variant.option2).replace('-', "") ||
            REBASE.theme.handleizeStr(split_filename[split_filename.length-2]).replace('-', "") === REBASE.theme.handleizeStr(variant.option3).replace('-', "");
          }
        });
	
//         thumbs_container.empty();
//         main_container.empty();
//         let variant_media_Limit = variant_media.slice(0,4);
// // 	console.log('PDP', variant_media.slice(0,4));
//         variant_media_Limit.forEach(function(media, index){
          
//           if ( media.media_type == 'image' ) {
//             thumbs_container.append('<a href="#" data-src="' + Shopify.resizeImage(media.src, '1600x') + '"><img src="' + Shopify.resizeImage(media.src, '800x') + '" alt="' + media.alt + ' Image ' + index + '" /></a>');
//           }
//         });

//         main_container.html('<img src="' + Shopify.resizeImage(variant_media[0].src, '1600x') + '" alt="' + variant_media[0].alt + '" />');
//      
      },

      _updateQuickViewDetailsLink: function (e) {
        var details_btn = $('.view-details-btn', this.$container),
            existing_link = details_btn.attr('href');
//             new_link = existing_link.split('?')[0] + '?variant=' + e.variant.id;

//         details_btn.attr('href', new_link);
//         $('.dropdown__option.available').each(function(index, obj) {
//           if (index === 0) {
//             const $radios = $(`#${obj.id} input[type=radio]`);
//             if ($radios.is(':checked') === false) {
//               $radios.prop('checked', true);
//             }
//           }


//         });


      }
    });

    return Product;
  })();

  /* ----------------------------------------------------------------
  -------------------------------------------------------------------
  Product Variants class - based on Shopify debut
  -------------------------------------------------------------------
  -----------------------------------------------------------------*/

  REBASE.theme.Variants = (function() {
    function Variants(options) {
      this.$container = options.$container;
      this.product = options.product;
      this.single_option_selector = options.single_option_selector;
      this.original_select_id = options.original_select_id;
      this.enable_history_state = options.enable_history_state;
      this.current_variant = {};
      this.quickView = options.quickView;

      $(this.single_option_selector, this.$container).on('change', this._onSelectChange.bind(this));
    }

    Variants.prototype = $.extend({}, Variants.prototype, {
      /**
       * Get the currently selected options from add-to-cart form. Works with all
       * form input elements.
       *
       * @return {array} options - Values of currently selected variants
       */
      _getCurrentOptions: function() {
        var should_filter = false,
            the_options = $.map($(this.single_option_selector, this.$container), function(element) {
              var $element = $(element),
                  type = $element.attr('type'),
                  current_option = {};

              if (type === 'radio' || type === 'checkbox') {
                should_filter = true;

                if ($element[0].checked) {
                  current_option.value = $element.val();
                  current_option.index = $element.data('index');
                  return current_option;
                } else {
                  return false;
                }
              } else {
                current_option.value = $element.val();
                current_option.index = $element.data('index');
                return current_option;
              }
            });

        // Remove any unchecked input values if using radio buttons or checkboxes
        // Removes all falsy values (Boolean constructor is a function, if the value is omitted or is 0, -0, null, false, NaN, undefined, or the empty string ("") then it will get removed)
        if (should_filter) {
          the_options = the_options.filter(Boolean);
        }

        return the_options;
      },

      /**
       * Find variant based on selected values.
       *
       * @param  {array} selected_values - Values of variant inputs
       * @return {object || undefined} found - Variant object from product.variants
       */
      _getVariantFromOptions: function() {
        var selected_values = this._getCurrentOptions(),
            variants = this.product.variants,
            all_variants_match_option1,
            found;

        found = $.grep(variants, function(variant) {
          return selected_values.every(function(values) {
            return variant[values.index] === values.value;
          });
        });

        all_variants_match_option1 = $.grep(variants, function(variant) {
          return variant[selected_values[0].index] === selected_values[0].value;
        });

        if (found.length) {
          found = found[0];
        } else {
          found = undefined;
        }

        return {
          variant_match: found,
          all_variants_match_option1: all_variants_match_option1
        };
      },

      /**
       * Event handler for when a variant input changes.
       */
      _onSelectChange: function(e) {
        var variant_from_options = this._getVariantFromOptions(),
            variant;

        variant = variant_from_options.variant_match;

        this.$container.trigger({
          type: 'variantChange',
          variant: variant,
          all_variants_match_option1: variant_from_options.all_variants_match_option1,
          target: e.target
        });

        if (!variant) {
          this.current_variant = {};
          return;
        }

        // trigger an extra event on the document for wishlist plus to listen to
        if ( this.quickView ) {
          $(document).trigger({
            type: 'variantChange',
            variant: variant
          });
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateSKU(variant);
        this.current_variant = variant;
		
        if (this.enable_history_state) {
          this._updateHistoryState(variant);
        }
      },

      /**
       * Trigger event when variant image changes
       *
       * @param  {object} variant - Currently selected variant
       * @return {event}  variantImageChange
       */
      _updateImages: function(variant) {
        var variant_image = variant.featured_image || {},
            current_variant_image = this.current_variant.featured_image || {};

        if (!variant.featured_image || variant_image.src === current_variant_image.src) {return;}

        this.$container.trigger({
          type: 'variantImageChange',
          variant: variant
        });
      },

      /**
       * Trigger event when variant price changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantPriceChange
       */
      _updatePrice: function(variant) {
        if (variant.price === this.current_variant.price && variant.compare_at_price === this.current_variant.compare_at_price) {return;}

        this.$container.trigger({
          type: 'variantPriceChange',
          variant: variant
        });
      },

      /**
       * Trigger event when variant sku changes.
       *
       * @param  {object} variant - Currently selected variant
       * @return {event} variantSKUChange
       */
      _updateSKU: function(variant) {
        if (variant.sku === this.current_variant.sku) {return;}

        this.$container.trigger({
          type: 'variantSKUChange',
          variant: variant
        });
      },

      /**
       * Update history state for product deeplinking
       *
       * @param  {variant} variant - Currently selected variant
       * @return {k}         [description]
       */
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {return;}
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({ path: newurl }, '', newurl);
      },

      /**
       * Update hidden master select of variant change
       *
       * @param  {variant} variant - Currently selected variant
       */
      _updateMasterSelect: function(variant) {
        $(this.original_select_id, this.$container).val(variant.id).data('selected-variant-id', variant.id);
        $('#product-supplier-style').text($('option:selected', this.original_select_id, this.$container).data('variant-ss'));
      }
    });

    return Variants;
  })();
})(jQuery);
function getProductData(target, handle, currentColor) {
  
   let current_variant = $(".dropdown__option--selected").attr("data-varaint-id");
   $("#add-to-cart").removeClass("d-none");
   $("#notify-text-button").addClass("d-none");
   $(".swatch-element").removeClass("selected-swatch");
   $("input[value='"+currentColor+"']").parent("div").addClass("selected-swatch");

   const parentGroup = target.closest('.swatch-group');
   if (parentGroup) {
     const currentColorSpan = parentGroup.querySelector('.quick-view-color-wrap');
     if (currentColorSpan) {
       currentColorSpan.textContent = currentColor;
     }
     const siblingGroups = parentGroup.parentElement.querySelectorAll('.swatch-group');
     siblingGroups.forEach(group => {
       if (group !== parentGroup) {
         const colorSpan = group.querySelector('.quick-view-color-wrap');
         if (colorSpan) {
           colorSpan.textContent = '';
         }
       }
     });
   }

    document.dispatchEvent(new CustomEvent("change"));
  
   $.getJSON(window.Shopify.routes.root + 'products/'+handle+'.json', function(product) {
     
	 $('.product-quickview').html();
     var quickview = $('.product-quickview');
     quickview.find('.product-quickview__header h2').html(product.product.title);

     var featuredImage = Shopify.resizeImage(product.product.image.src, '1200x');
      quickview.find('.product-quickview__image').html('<img src="' + featuredImage + '" title="' + product.title + '"/>');
     if (product.product.images.length > 1) {
       quickview.find('.product-quickview__thumbs').empty();
       var quickViewCarousel = quickview.find('.product-quickview__thumbs');
       var count = 0;
       
       for (i in product.product.images) {
         if (count < product.product.images.length) {
           var grande = Shopify.resizeImage(product.product.images[i].src, '1200x');
           var compact = Shopify.resizeImage(product.product.images[i].src, 'compact');
           var item = '<div class="slide"><a href="javascript:void(0)" data-src="' + grande + '"><img src="' + compact + '"  /></a></div>'

           quickViewCarousel.append(item);
           count = count + 1;
         }
       }
       $('.product-quickview__thumbs').removeClass('slick-initialized slick-slider slick-vertical');
       $('.product-quickview__thumbs').slick({
         dots: false,
         infinite: false,
         slidesToShow: 4,
         slidesToScroll: 1,
         arrows: true,
         vertical: true,
         prevArrow: '<div class="slick_button"><svg height="24" viewBox="0 0 14 24" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m165 368 10 10 10-10" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2.4" transform="matrix(0 1 -1 0 380 -163)"></path></svg></div>',
         nextArrow: '<div class="slick_button"><svg height="24" viewBox="0 0 14 24" width="14" xmlns="http://www.w3.org/2000/svg"><path d="m699 368 10 10 10-10" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2.4" transform="matrix(0 1 1 0 -366 -697)"></path></svg></div>'
       });
     }
     
 	 var get_swatches = JSON.parse(document.getElementById('variant__inv_'+product.product.id).innerHTML);
     get_swatches = get_swatches.variants.filter(x => x.option1 == currentColor);
     
     let check_inventory = get_swatches.filter(x => x.inv > 0);
     
     var swatches = {
       "variants": get_swatches
     }
     
     var currentColorList = [];
     let findSizeQuick = [];
     var cantFindList = [];
     let find_size = 0;
     
      for(var j = 0; j < swatches.variants.length; j++){
        
       	var swatchesColor = swatches.variants[j].option1;
        var swatchesSize = swatches.variants[j].option2;
       
        if (swatches.variants[j].compare_at_price) {
          $(".product-quickview__price.product-quickview__price--current").html(Shopify.formatMoney(swatches.variants[j].price, ''));
          $(".product-quickview__price.product-quickview__price--old").html(Shopify.formatMoney(swatches.variants[j].compare_at_price, ''));
          $(".product-quickview__price.product-quickview__price--current").addClass("product-quickview__price--on-sale product-price--on-sale");
          $(".product-quickview__price.product-quickview__price--old").show();
       
        } else {
          $(".product-quickview__price.product-quickview__price--current").html(Shopify.formatMoney(swatches.variants[j].price, ''));
           $(".product-quickview__price.product-quickview__price--current").removeClass("product-quickview__price--on-sale product-price--on-sale");
          $(".product-quickview__price.product-quickview__price--old").hide();
        }
        
        
        if (swatches.variants[j].inv > 0) {
          currentColorList.push(`<div class="variant-wrap"><div id="${swatches.variants[j].id}" data-varaint-id="${swatches.variants[j].id}" class="dropdown__option available" tabindex="0" data-label="0" data-position="2" data-value="${swatches.variants[j].option2}"><input type="radio" name="single-option-select-2" id="swatch-2-${swatches.variants[j].option2}" value="${swatches.variants[j].option2}" data-index="option2" class="single-option-select visually-hidden"><label for="swatch-2-${swatches.variants[j].option2}"><div>${swatches.variants[j].option2}</div></label></div></div>`);
            // $("#option-name--option1 span").html(currentColor);
          
            cantFindList.push(`<a href="JavaScript:void(0);" class="back-in-stock-trigger back-in-stock-btn quick_stock_wrap"><span class="back-in-stock-btn"></span></a>`);
            $(".quick_stock_wrap").html(cantFindList);
        }
        else {
           find_size = 1;
            currentColorList.push(`<div id="${swatches.variants[j].id}" data-varaint-id="${swatches.variants[j].id}" class="dropdown__option dd dropdown__option--sold-out" tabindex="0" data-label="0" data-position="2" data-value="${swatches.variants[j].option2}"><input type="radio" name="single-option-select-2" id="swatch-2-${swatches.variants[j].option2}" value="${swatches.variants[j].option2}" data-index="option2" class="single-option-select visually-hidden"><label for="swatch-2-${swatches.variants[j].option2}"><div>${swatches.variants[j].option2}</div></label></div>`);
          //  $("#option-name--option1 span").html(currentColor);
            
          }
      }
     if (find_size == 1) {
       
       findSizeQuick.push(`<span class="dot_stock_wrap">:</span><a href="JavaScript:void(0);" class="back-in-stock-trigger back-in-stock-btn quick_stock_wrap"><span class="back-in-stock-btn">Can't find your size?</span></a>`);
       $(".quick_stock_wrap").html(findSizeQuick);
       $(".quick_hde").hide();
       
     } else {
       findSizeQuick = '';
       $(".quick_stock_wrap").html(findSizeQuick);
       $(".quick_hde").hide();
       
       
     }
     $('#swathes-load-id').html(currentColorList);
     
     if(check_inventory.length == 0) {
     	$('#add-to-cart').addClass('disabled').attr("disabled", true);
      $('#add-to-cart').attr('aria-disabled', true);
       $('#add-to-cart').text('Sold Out');
     }
     else {
     	$('#add-to-cart').removeClass('disabled').removeAttr('disabled');
       $('#add-to-cart').attr('aria-disabled', false);
       $('#add-to-cart').text('Add To Bag');
     }
       
     
     $('.dropdown__option.available').each(function(index, obj) {
       if (index === 0) {
         $('.dropdown__option').removeClass('dropdown__option--selected');
         $(this).addClass('dropdown__option--selected');
         const $radios = $(`#${obj.id} input[type=radio]`);
         if ($radios.is(':checked') === false) {
           $radios.prop('checked', true);
           $('#add-to-cart').removeClass('disabled').removeAttr('disabled');
           $('#add-to-cart').attr('aria-disabled', false);
           $('#add-to-cart').text('Add To Bag');
         }
       }
     });
     function swymCallbackFn(swat) {
      $(".product-quickview .product__wishlist").attr('data-product-id', product.product.id);
      $(swatches.variants).each(function(index, el) {
        if (el.inv > 0) {
          $(".product-quickview .product__wishlist").attr('data-variant-id', el.id);
          return false;
        }
      })
      let outOfStock = swatches.variants.every(item => item.inv === 0);
      if(outOfStock) {
        $(".product-quickview .product__wishlist").attr('data-variant-id', product.product.variants[0].id);
      }
      swat.initializeActionButtons(".product-quickview");
       $(document).on('change','.single-option-select', function() {
        $(".product-quickview .product__wishlist").attr('data-product-id', product.product.id);
          $(".product-quickview .product__wishlist").attr('data-variant-id', $(this).parent().attr('id'));
          swat.initializeActionButtons(".product-quickview");
       });
     }
     if (!window.SwymCallbacks) {
       window.SwymCallbacks = [];
     }
     window.SwymCallbacks.push(swymCallbackFn);
     
   });
  
 }

(function () {
  var FONT = "'Neutra Text', serif";
  var injected = new WeakSet();

  var targets = [
    {
      selector: 'shopify-payment-terms',
      css: 'span, button { font-family: ' + FONT + ' !important; }'
    },
    {
      selector: '[data-nametag="shop-portal-provider"]',
      css:
        'section, span, button, p, small, div { font-family: ' + FONT + ' !important; }' +
        '@media (max-width: 480px) {' +
        '  section[data-testid="authorize-modal"] {' +
        '    width: 350px !important;' +
        '    margin: 0 auto !important;' +
        '  }' +
        '}'
    }
  ];

  function inject(host, css) {
    if (!host.shadowRoot || injected.has(host.shadowRoot)) return;
    var style = document.createElement('style');
    style.textContent = css;
    host.shadowRoot.appendChild(style);
    injected.add(host.shadowRoot);
  }

  function scan(root) {
    targets.forEach(function (t) {
      if (root.nodeType === 1 && root.matches && root.matches(t.selector)) {
        inject(root, t.css);
      }
      if (root.querySelectorAll) {
        root.querySelectorAll(t.selector).forEach(function (el) {
          inject(el, t.css);
        });
      }
    });
  }

  scan(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();